import { forwardRef } from 'react'
import type { CSSProperties, TextareaHTMLAttributes } from 'react'
import { Field } from './field'

/** Labeled multi-line input. Same hint/error wiring as Input. */

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  hint?: string
  error?: string
  wrapperStyle?: CSSProperties
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, hint, error, wrapperStyle, ...rest },
  ref,
) {
  return (
    <Field label={label} hint={hint} error={error} style={wrapperStyle}>
      {(control) => <textarea ref={ref} className="it-textarea" {...control} {...rest} />}
    </Field>
  )
})
